/* ==========================================================================
   SNAG ECOM TEAM — sub-menu accordions for the Taiga 8.1 drawer nav
   ==========================================================================
   Replaces setupNestedAccordions() from the 6.x component-drawer-menu.js.

   Why this is a rewrite rather than a port: 6.x rendered every level as flat
   siblings, so the old code had to walk nextElementSibling and *infer* which
   level-2 items owned a level-3 group. 8.1 already groups them — a level-2 link
   is followed by a sibling <div class="sub-sub-menu"> holding its children — so
   detection is exact and the sibling-walking is gone.

   Behaviour matches live:
     - an item becomes an accordion ONLY if it actually has a third level
     - the chevron is the toggle; the row's <a> still navigates
     - opening one group closes any other open group
   ========================================================================== */

(function () {
  'use strict';

  var WRAP  = 'submenu-accordion';
  var BODY  = 'submenu-accordion-content';
  var CHEV  = 'submenu-chevron';
  var READY = 'data-snag-accordion-ready';

  var CHEVRON_SVG =
    '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"' +
    ' viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"' +
    ' stroke-linecap="round" stroke-linejoin="round" class="icon icon-chevron-right">' +
    '<polyline points="9 18 15 12 9 6"></polyline></svg>';

  var setupTimer;

  function closeOthers(current) {
    var open = document.querySelectorAll('.' + WRAP + '.is-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] === current) continue;
      open[i].classList.remove('is-open');
      var chev = open[i].querySelector('.' + CHEV);
      if (chev) chev.setAttribute('aria-expanded', 'false');
    }
  }

  function makeAccordion(link, group) {
    // Wrap the level-2 link and its level-3 group in a single accordion element.
    var wrap = document.createElement('div');
    wrap.className = WRAP;
    link.parentNode.insertBefore(wrap, link);

    var body = document.createElement('div');
    body.className = BODY;

    wrap.appendChild(link);
    body.appendChild(group);
    wrap.appendChild(body);

    group.setAttribute(READY, '');

    // Chevron is the toggle hit-area. Appended inside the link so it inherits the
    // row layout, but its handler stops propagation so the link still navigates.
    var chev = document.createElement('span');
    chev.className = CHEV;
    chev.setAttribute('role', 'button');
    chev.setAttribute('tabindex', '0');
    chev.setAttribute('aria-expanded', 'false');
    chev.setAttribute('aria-label', (link.textContent || '').trim());
    chev.innerHTML = CHEVRON_SVG;
    link.appendChild(chev);

    function toggle(ev) {
      if (ev) { ev.preventDefault(); ev.stopPropagation(); }
      var willOpen = !wrap.classList.contains('is-open');
      closeOthers(wrap);
      wrap.classList.toggle('is-open', willOpen);
      chev.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }

    chev.addEventListener('click', toggle);
    chev.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') toggle(ev);
    });
  }

  function setup() {
    var links = document.querySelectorAll('.drawer-menu-nav .sub-menu-link');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.closest('.' + WRAP)) continue;               // already processed

      var group = link.nextElementSibling;
      if (!group || !group.classList.contains('sub-sub-menu')) continue;
      if (!group.querySelector('a')) continue;              // empty group, skip

      makeAccordion(link, group);
    }
  }

  function scheduleSetup() {
    clearTimeout(setupTimer);
    setupTimer = setTimeout(setup, 60);
  }

  function init() {
    setup();

    var nav = document.querySelector('.drawer-menu-nav');
    if (nav && !nav._snagAccInit) {
      nav._snagAccInit = true;
      // The drawer renders its panels lazily, so re-run as nodes appear.
      new MutationObserver(scheduleSetup).observe(nav, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', scheduleSetup);
})();
